<template>
  <div class="output">
      <div class="count"><p></p></div>
      <div class="error"><p></p></div>
      <div class="spec-char"><p></p></div>
  </div>
</template>

<script>
export default {
    name: 'StringOutput',
}
</script>

<style>
.output {
    opacity: 0;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly;
    align-items: center;
    transition: ease-in .5s all;
    min-height: 140px;
}
</style>